module.exports = __webpack_public_path__ + "img/melee-icon.e5d8797f.svg";